import { IBrandInput } from "./BuilderRetailerBrandTileSection";
import { IProductInput } from "./BuilderRetailerProductTileSection";

export function deduplicateProductsOrBrands<
  T extends IProductInput | IBrandInput,
>(items: T[]): T[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    if (seen.has(item.token)) {
      return false;
    }
    seen.add(item.token);
    return true;
  });
}
